import validator from 'validator';
import i18n from '@/plugins/v18n';
import { CountryCode, isValidNumberForRegion } from 'libphonenumber-js';

type ValidationRule<T> = (inp: T) => boolean | string;

export const IsNumber: ValidationRule<string | number> = (inp) => {
  const stringed = inp.toString();
  return stringed.length === 0
    ? true
    : validator.isNumeric(stringed)
      ? true
      : i18n.global.t('validation.not-numeric').toString();
};

export const IsInteger: ValidationRule<string | number> = (inp) => {
  if (!inp) return true; // Allow empty input
  const stringed = inp.toString();
  return stringed.length === 0
    ? true
    : validator.isInt(stringed)
      ? true
      : i18n.global.t('validation.number-must-be-integer').toString();
};

export const IsPositive: ValidationRule<string | number> = (inp) => {
  const stringed = inp.toString();
  return stringed.length === 0
    ? true
    : validator.isNumeric(stringed) && parseInt(stringed) > 0
      ? true
      : i18n.global.t('validation.number-must-be-positive').toString();
};

export const NonEmpty: ValidationRule<string> = (inp) => {
  return inp && !validator.isEmpty(inp.trim()) ? true : i18n.global.t('validation.required-field').toString();
};

/**
 *
 */
export function StringMinLength(len: number): ValidationRule<string> {
  return (inp) => {
    return validator.isLength(inp, { min: len }) ? true : i18n.global.t('validation.string-min-length').toString();
  };
}

/**
 *
 */
export function PasswordMinLength(len: number): ValidationRule<string> {
  return (inp) => {
    return StringMinLength(len)(inp) === true
      ? true
      : i18n.global.t('validation.password-min-length', [len]).toString();
  };
}

export const IsEmail: ValidationRule<string> = (inp) => {
  if (typeof inp !== 'string') return false;
  return validator.isEmail(inp.trim()) ? true : i18n.global.t('validation.invalid-email').toString();
};

/**
 *
 */
export function IsValidPhoneNumber(country: CountryCode = 'CH'): ValidationRule<string> {
  return (inp) => {
    if (inp.length === 0) return '';
    return isValidNumberForRegion(inp, country) ? true : i18n.global.t('validation.invalid-phone').toString();
  };
}

export const SelectOne: ValidationRule<[] | string> = (inp) => {
  return inp || (typeof inp === 'string' && inp.length > 0) ? true : i18n.global.t('validation.select-one').toString();
};

export const SelectAtLeastOne: ValidationRule<[] | string> = (inp) => {
  return inp.length > 0 ? true : i18n.global.t('validation.select-at-least-one').toString();
};

const validationFunctions = {
  IsNumber,
  IsInteger,
  IsPositive,
  NonEmpty,
  StringMinLength,
  PasswordMinLength,
  IsEmail,
  IsValidPhoneNumber,
  SelectOne,
  SelectAtLeastOne,
};

export default validationFunctions;
